export const REPORT_ORIGIN_VALUES = ['user', 'issue_replay'] as const;

/** What started an interpretation's generation: a user, or an issue replay. */
export type ReportOrigin = (typeof REPORT_ORIGIN_VALUES)[number];

export const REPORT_ORIGINS: readonly { value: ReportOrigin; label: string }[] =
  [
    { value: 'user', label: 'User runs' },
    { value: 'issue_replay', label: 'Replays' },
  ];
